import i18n from 'i18n';
import {isFieldRestricted, getRestrictedFieldPlaceholder, getRestrictedFieldClassName} from '@/utils/fieldRestrictions';

const RenderNoDataAvailable = () => {
    return (
        <span style={{fontSize: '0.9rem'}} className="d-block mt-1 text-muted">{i18n.t('jt_data_available.text')}</span>
    );
};

/**
 * Renders either a restricted field indicator or "No Data Available" based on
 * whether the field was redacted or simply has no data.
 */
export const RenderFieldValue = ({
    value,
    fieldName,
    restrictedFields,
}: {
    value: any;
    fieldName: string;
    restrictedFields?: string[] | null;
}) => {
    if (value) {
        return <>{value}</>;
    }
    if (isFieldRestricted(fieldName, restrictedFields)) {
        return <RestrictedFieldIndicator />;
    }
    return <RenderNoDataAvailable />;
};

/**
 * Consistent restricted field indicator used everywhere.
 * Shows "[Restricted]" with debug badge styling when audit mode is active.
 */
export const RestrictedFieldIndicator = () => {
    return (
        <span className={getRestrictedFieldClassName()}>
            {getRestrictedFieldPlaceholder()}
        </span>
    );
};

/**
 * Restricted field placeholder styled as a disabled form input.
 * Use in place of select/input components when the field is restricted.
 */
export const RestrictedFieldInput = () => {
    return (
        <div className="text-muted" style={{
            minHeight: '38px',
            padding: '8px 12px',
            border: '1px solid hsl(0, 0%, 80%)',
            borderRadius: '4px',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
        }}>
            {getRestrictedFieldPlaceholder()}
        </div>
    );
};

export default RenderNoDataAvailable;